import { render, staticRenderFns } from "./QuestionImageUpload.vue?vue&type=template&id=18b2cae9&scoped=true&"
import script from "./QuestionImageUpload.vue?vue&type=script&lang=js&"
export * from "./QuestionImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./QuestionImageUpload.vue?vue&type=style&index=0&id=18b2cae9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b2cae9",
  null
  
)

export default component.exports